// extracted by mini-css-extract-plugin
export var button = "markdown-module--button--0qnyG";
export var buttonLink = "markdown-module--button-link--sBpxB";
export var markdown = "markdown-module--markdown--Jywyh";